import type { Theme } from "@mui/material/styles";

/**
 * Desktop: canto INFERIOR direito. No topo ele cobria justamente "Convidar
 * time" e "Adicionar time" — os botões que o organizador ia clicar em seguida.
 * Embaixo não mora nenhuma ação primária.
 */
export const APP_TOAST_DESKTOP_POSITION = "bottom-right" as const;

/** Mobile: rodapé, largura cheia menos a calha lateral. */
export const APP_TOAST_MOBILE_POSITION = "bottom-center" as const;

/**
 * O toast fica acima de QUALQUER overlay. As folhas do cadastro de time e do
 * elenco sobem a 1700 e a edição de partida aninhada chega a 1900: empatado
 * em 1700, o toast perdia pela ordem no DOM (a folha abre depois) e o "Time
 * criado" disparava escondido atrás dela. Suba este número se algum overlay
 * passar dele.
 */
export const APP_TOAST_Z_INDEX = 2000;

/** Sem ação: some sozinho. Com ação: o dobro, porque há o que clicar. */
export const APP_TOAST_DURATION_MS = 4000;
export const APP_TOAST_ACTION_DURATION_MS = 7000;

export const APP_TOAST_DESKTOP_WIDTH_PX = 360;
export const APP_TOAST_MOBILE_SIDE_MARGIN_PX = 12;
export const APP_TOAST_MOBILE_MAX_WIDTH_PX = 400;

/** Distância do rodapé no mobile (bottom bar + safe area). */
export const APP_TOAST_MOBILE_BOTTOM_OFFSET_PX = 84;

export const APP_TOAST_DESKTOP_OFFSET_PX = 16;

export type AppToastPosition =
  | typeof APP_TOAST_DESKTOP_POSITION
  | typeof APP_TOAST_MOBILE_POSITION;

export function getAppToastPosition(isMobile: boolean): AppToastPosition {
  return isMobile ? APP_TOAST_MOBILE_POSITION : APP_TOAST_DESKTOP_POSITION;
}

export function getAppToastOffset(isMobile: boolean): number | string {
  if (isMobile) {
    return `calc(env(safe-area-inset-bottom, 0px) + ${APP_TOAST_MOBILE_BOTTOM_OFFSET_PX}px)`;
  }
  return APP_TOAST_DESKTOP_OFFSET_PX;
}

/** Largura do toaster Sonner — centralizado na viewport no mobile. */
export function getAppToastContainerWidth(theme: Theme, isMobile: boolean): string | number {
  if (isMobile) {
    return `min(${APP_TOAST_MOBILE_MAX_WIDTH_PX}px, calc(100vw - ${APP_TOAST_MOBILE_SIDE_MARGIN_PX * 2}px))`;
  }
  return APP_TOAST_DESKTOP_WIDTH_PX;
}
